import { action, runInAction } from 'mobx';
import { BookingDetailBase } from '@link/share/stores';
import { bookingApi } from '@link/supplier/services';

export class BookingDetail extends BookingDetailBase {
  async init(bookingCustomId: string) {
    const res = await this.getBooking(bookingCustomId);
    if (res?.booking?.id) {
      await this.getAllDiscrepancies(res.booking.id);
    }
  }

  @action
  getBooking(bookingCustomId: string) {
    return bookingApi.getBooking({ customId: bookingCustomId }).then(res => {
      runInAction(() => {
        this.bookingDetail = res;
      });
      return res;
    });
  }

  @action
  getAllDiscrepancies(bookingId: string) {
    return bookingApi.getAllDiscrepancies({ bookingId }).then(res => {
      runInAction(() => {
        this.discrepancyRequests = res?.discrepancyRequests || [];
      });
    });
  }
}

export default new BookingDetail();
